import { useUserRole } from "../UserRoleContext";
import { useNavigate } from "react-router-dom";

export default function AdminPage() {
  const role = useUserRole();
  const navigate = useNavigate();
  if (role !== "admin") {
    return <div className="page-container">Access denied.</div>;
  }
  return (
    <div className="page-container">
      <h2>Admin Panel</h2>
      <p>Only admins can see this page.</p>
      <button onClick={() => navigate("/admin/tag-reference")}> 
        Edit GTM Tag References
      </button>
      <button onClick={() => navigate("/admin/product-event-owners")} style={{ marginLeft: "0.5rem" }}>
        Edit Product Event Owners
      </button>
    </div>
  );
}
